import {Button, Modal} from 'react-bootstrap';
import React, {useEffect, useState} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {IAlbum} from '../../interfaces/PlayerModels';
import {useEditAlbum} from '../../utils/api';
import AlbumFormUI, {AlbumFormData} from '@components/forms/AlbumFormUI';

interface IProps {
    album: IAlbum;
}

const EditAlbumModal: React.FC<IProps> = (props) => {
    const mutation = useEditAlbum();
    const {album} = props;
    const [show, setShow] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    // Form
    const form = useForm<AlbumFormData>({
        mode: 'onChange',
        defaultValues: album
    });
    const {handleSubmit, formState} = form;

    const saveAlbum: SubmitHandler<AlbumFormData> = async (data) => {
        setSubmitError(false);

        try {
            // Clone the data and remove the ID from the request body.
            const albumData: Partial<IAlbum> = Object.assign({}, data);
            if (albumData.hasOwnProperty('id')) delete albumData.id;

            // Fire off the mutation to save the album.
            await mutation.mutateAsync({albumId: data.id, data: albumData});

            // Successfully saved the album, close the modal.
            setShow(false);

            window.location.reload();

        } catch (e) {
            // There was an error saving the album, show an error message.
            setSubmitError(true);
        }
    };

    useEffect(() => {
        if (!show) {
            // When this component is about to hide itself, reset the form.
            form.reset();
            setSubmitError(false);
        }
    }, [form, show]);

    useEffect(() => {
        // When the album prop changes, set the values in the form to the new value.
        form.reset(album);
    }, [form, album]);

    return (
        <>
            <Button onClick={() => setShow(true)}><i className={'bi bi-pencil'} title={'Edit'}/></Button>
            <Modal size={'lg'} show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Edit album <span className={'text-muted fs-6 ms-2'}>{album.id}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AlbumFormUI form={form}/>
                </Modal.Body>
                <Modal.Footer>
                    {submitError &&
                        <p className={'text-danger'}>There was an error saving the album. Please try again.</p>}
                    <Button variant="danger" onClick={() => setShow(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" disabled={!formState.isValid} onClick={handleSubmit(saveAlbum)}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EditAlbumModal;